import { useGetMyIntroductions } from '@queries/introductions';
import { withAuthGate } from '@sunrise-ui/composites';
import { Loader, useAuthStore } from '@sunrise-ui/primitives';
import InboxIntroductionView from '@templates/InboxIntroductionView';
import React from 'react';

function PendingIntrosScreen() {
  const { currentUserId } = useAuthStore();
  const { isLoading: isLoadingIntros, data: introductions } =
    useGetMyIntroductions({
      userId: currentUserId,
      state: 'pending',
    });

  if (isLoadingIntros) return <Loader size="large" />;

  return (
    <InboxIntroductionView intros={introductions ?? []} variant="pending" />
  );
}

export default withAuthGate(PendingIntrosScreen);
